module.exports = __webpack_public_path__ + "static/media/oberflex-makoremoire-2560x1440.c1797555.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-makoremoire-2560x1440.jpg
// module id = 1031
// module chunks = 37